export let VIDEO_CARDS_BI_ORIGIN = /*#__PURE__*/function (VIDEO_CARDS_BI_ORIGIN) {
  VIDEO_CARDS_BI_ORIGIN["VIDEO"] = "video";
  VIDEO_CARDS_BI_ORIGIN["ALL_CARDS"] = "all_cards";
  return VIDEO_CARDS_BI_ORIGIN;
}({});
//# sourceMappingURL=video-cards-origin.js.map